<template>
  <v-item v-slot="{ toggle }" :value="value">
    <v-btn
      tile
      elevation="0"
      class="flex-grow-1"
      height="100%"
      :class="classes"
      :disabled="disabled"
      @click="toggle"
    >
      <div class="pa-3 d-flex flex-column">
        <v-icon
          class="mb-2 material-icons-outlined"
          :color="iconColor"
        >
          {{ icon }}
        </v-icon>
        <v-chip small class="px-2" :class="chipClasses">
          <span class="font-weight-bold">{{ count }}</span>
        </v-chip>
      </div>
    </v-btn>
  </v-item>
</template>

<script>
export default {
  name: 'ListTabItem',
  props: {
    value: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        primary: this.selected,
      };
    },
    chipClasses() {
      return {
        ['grey--text text--darken-2']: !this.selected,
        white: this.selected,
        ['primary--text']: this.selected,
      };
    },
    iconColor() {
      return this.selected ? 'white' : 'grey darken-2';
    },
  },
};
</script>
